/**
 * @fileoverview GET handler for the "/custom_objects/onboarding_status" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsOnboardingStatus } from "./constants";
import type { GetCustomObjectsOnboardingStatusResult } from "./types";
import { isGetCustomObjectsOnboardingStatusResult } from "./validators";

export const getCustomObjectsOnboardingStatus = reactQueryFetcherAdapter(
  customObjectsOnboardingStatus,
  (signal: AbortSignal): Promise<GetCustomObjectsOnboardingStatusResult> => {
    return fetch("/custom_objects/onboarding_status", "GET", {}, { signal }, { propagateFetchRequestError: false });
  },
  isGetCustomObjectsOnboardingStatusResult
);
